import React from "react";
import "./DashCard.css";
import { Typography, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CardMedia from "@mui/material/CardMedia";
import defaultBlogImage from "../../assets/default-blog.png";
import dayjs from "dayjs";

export const DashCard = ({ type, value, token, deleteBerth, editBerth }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  // console.log("card data: ", value);
  if (value === undefined) {
    return "--";
  }

  const {
    transactionType,
    totalAmount,
    bookingDate,
    sourceBerth: {
      berthImagePath,
      name,
      currentLocation,
      berthSpecifications: { length, dockHeight, beam, depth },
    },
  } = value;

  const handleNavigate = () => {
    if (type === "request" || type === "own_request") {
      navigate("berth-detail", {
        state: { type, value },
      });
      return;
    }

    return;
  };

  return (
    <Card className="BearthCard" onClick={handleNavigate}>
      <CardMedia
        component="img"
        alt="berth-image"
        sx={{ height: "160px", borderRadius: "2px" }}
        image={
          berthImagePath ? `${baseUrl}${berthImagePath}` : defaultBlogImage
        }
      />
      <CardContent style={{ paddingBottom: '16px' }}>
        <div className="bearth-details-container">
          <div className="bearth-content-row">
            <div className="title-data">
              <Typography className="bearth-title" variant="h4" component="h4">
                {name ? name : "--"}
              </Typography>
            </div>
            <div className="type-data">
              <div
                className={`cardTypeBox ${
                  transactionType
                    ? transactionType === "hire or swap"
                      ? "hireOrSwap"
                      : transactionType
                    : "hireOrSwap"
                }`}
              >
                Open to {transactionType ? transactionType : "--"}
              </div>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="amount-data">
              <p>Total Amount: <strong>€{totalAmount ? totalAmount : "--"}</strong></p>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="location-data">
              <p>Location: {currentLocation?.name ? currentLocation?.name : "--"}</p>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="left-data">
              <p>Length: <strong>{length ? length : "--"}m</strong></p>
            </div>
            <div className="right-data">
              <p>Beam: <strong>{beam ? beam : "--"}m</strong></p>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="left-data">
              <p>Depth: <strong>{depth ? depth : "--"}m</strong></p>
            </div>
            <div className="right-data">
              <p>Dock height: <strong>{dockHeight ? dockHeight : "--"}m</strong></p>
            </div>
          </div>
          <div className="bearth-content-row">
            <div className="booking-data">
              <p>
                Booking period:{" "}
                {bookingDate
                  ? dayjs(bookingDate?.startDate).format("YYYY-MM-DD")
                  : "--"}{" "}
                to{" "}
                {bookingDate
                  ? dayjs(bookingDate?.endDate).format("YYYY-MM-DD")
                  : "--"}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
